import { Users } from "pages";

const user_routes = [
  {
    path: "/users",
    component: Users.List,
  },
  {
    path: "/users/new",
    component: Users.Create,
  },
  {
    path: "/users/:id",
    component: Users.Edit,
  },
];

export default user_routes;
